import React, { useState } from "react";
import FaleAPI from "fale";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  return (
    <div className="main-container" style={{ paddingLeft: "0px" }}>
      <div className="content-wrapper-scroll">
        <div className="content-wrapper">
          <div className="login-container">
            <div className="container-fluid h-100">
              <div className="row no-gutters h-100">
                <div className="col-12">
                  <div className="login-wrapper">
                    <div className="login-screen">
                      <div className="login-body">
                        <img
                          style={{ width: "70px" }}
                          src="/assets/img/logo.png"
                          alt="Uni Pro Admin"
                        />
                        <h6>
                          Welcome to the Fale Portal,
                          <br />
                          Log in to your account.
                        </h6>
                        <div className="field-wrapper">
                          <input
                            type="email"
                            autoFocus={true}
                            value={email}
                            onChange={(event) => setEmail(event.target.value)}
                          />
                          <div className="field-placeholder">Email</div>
                        </div>
                        <div className="field-wrapper">
                          <input
                            type="password"
                            value={password}
                            onChange={(event) =>
                              setPassword(event.target.value)
                            }
                          />
                          <div className="field-placeholder">Password</div>
                        </div>
                        <div className="actions">
                          <button
                            className="btn btn-primary ms-auto"
                            onClick={async () => {
                              const user = await FaleAPI.authentication.login(
                                email,
                                password
                              );

                              localStorage.setItem("sessionToken", user.hash);

                              window.location.href = "/orders";
                            }}
                          >
                            Log In
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
